import { IIntegratedCare } from '@alberta/konexi-shared';
import { Injectable } from '@angular/core';
import { BaseStateExtension } from 'src/app/common/state/state-extension';
import { IntegratedCareModelName } from 'src/app/shared/models/model-names';
import { IntegratedCareViewModel } from './integratedcare-view-model';

@Injectable({ providedIn: 'root' })
export class IntegratedCareStateExtension extends BaseStateExtension<IIntegratedCare> {
  public get name(): string {
    return IntegratedCareModelName;
  }

  async canBeStored(item: IIntegratedCare): Promise<boolean> {
    return true;
  }

  protected afterCreateInternal(item: IIntegratedCare): void {}

  protected async afterUpdateInternal(item: IIntegratedCare): Promise<void> {
    if (
      this.stateRegistry.get<IIntegratedCare, IntegratedCareViewModel>(IntegratedCareModelName, 'selectedItem')?._id ===
      item?._id
    ) {
      await this.stateRegistry.update(IntegratedCareModelName, 'selectedItem', item);
    }
  }
  protected removeFromState(item: IIntegratedCare): void {}
}
